import { RegisterOptions, UseFormReturn } from 'react-hook-form';

export default function useSubmitOnChange(form: UseFormReturn<any>, callback: () => void) {
	function registerSubmitOnChange(id: any, options?: RegisterOptions) {
		const originalValues = form.register(id, options);

		function onChange(e: React.ChangeEvent<HTMLInputElement>) {
			originalValues.onChange(e);
			callback();
		}

		return { ...originalValues, id, onChange };
	}

	return {
		registerSubmitOnChange,
	};
}
